import { Button, Typography } from "@mui/material";
import __ from "src/utils/Translations";
import {
  DataSource,
  handleDownload,
} from "src/Pages/Company/OrganizationStructure/DataManagment/Utils/handleDownload";
import { ContentType } from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureAreas/DataManagment/DataManagment.models";

const Export = ({
  companyId,
  structureId,
}: {
  companyId: string;
  structureId: string;
}) => (
  <>
    <Button
      onClick={() =>
        handleDownload(
          companyId,
          structureId,
          ContentType.CSV,
          DataSource.STRUCTURES
        )
      }
      variant="contained"
      sx={{
        padding: "16px 12px",
        width: "100%",
      }}
    >
      <Typography sx={{ fontSize: "13px", fontWeight: "700" }}>
        {__("Eksportuj plik CSV")}
      </Typography>
    </Button>
    <Button
      onClick={() =>
        handleDownload(
          companyId,
          structureId,
          ContentType.XLSX,
          DataSource.STRUCTURES
        )
      }
      variant="contained"
      sx={{
        padding: "16px 12px",
        width: "100%",
      }}
    >
      <Typography sx={{ fontSize: "13px", fontWeight: "700" }}>
        {__("Eksportuj plik XLSX")}
      </Typography>
    </Button>
  </>
);

export default Export;
